var map = {
	"./dev/config.json": 1860,
	"./prod/config.json": 1861,
	"./qa/config.json": 1862,
	"./qa2/config.json": 1863,
	"./sandbox-partner/config.json": 1864,
	"./sandbox/config.json": 1865,
	"./uat/config.json": 1866,
	"./uat2/config.json": 1867,
	"./uat3/config.json": 1868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1859;